import { connect } from 'react-redux';
import { UPLOAD_MULTIPLE_MEDIA } from 'store/media/actionTypes';
import { actionGetGiftDetails, actionUpdateGift } from 'store/gift/actions';

import ManagerDetail from './ManagerDetail';

const mapStateToProps = (state) => ({
  isLoadingUploadMultipleMedia: state.Media.isLoadingUploadMultipleMedia,
  giftDetails: state.Gift.giftDetails,
  isLoadingGetGiftDetails: state.Gift.getDetailsLoading,
  isUpdateGiftLoading: state.Gift.updateLoading,
});

const mapDispatchToProps = (dispatch) => ({
  actionUploadMultiMedia: (payload) => dispatch({
    type: UPLOAD_MULTIPLE_MEDIA,
    payload,
  }),
  actionGetGiftDetails: (payload) => dispatch(actionGetGiftDetails(payload)),
  actionUpdateGift: (payload) => dispatch(actionUpdateGift(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerDetail);
